import { Directive, ElementRef, Renderer2, Input, OnInit } from '@angular/core';
import { RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { EncriptDecriptService } from '../../../services/encriptdecript';

@Directive({
  selector: '[appRoleControls]'
})
export class RoleControlsDirective implements OnInit {
  // userDetail =
  private userDetail:any;
  private userObj:any;
  constructor(private elem: ElementRef, private renderer: Renderer2,
    private encriptDecript:EncriptDecriptService) { 
    this.userObj = this.encriptDecript.getLocalStorage('userObject');
    this.userDetail=JSON.parse(this.userObj);
   }

  @Input() appRoleControls: string;
  @Input() roleControlComponentCode: string;

  ngOnInit() {
    if (this.userDetail.isAdmin) {
      return null;
    } else if (this.checkComponentPermission()) {

      this.renderer.setAttribute(this.elem.nativeElement, 'disabled', 'true');
      this.renderer.addClass(this.elem.nativeElement, 'active');
      return false;
    } else {
      return true;
    }
  }

  private checkComponentPermission() {
    const role = this.userDetail.roles[0];
    for (const permission of role.applicationRolePermission) {
      if (this.roleControlComponentCode === permission.component.code) {
        return !permission[this.appRoleControls];
      }
    }
  }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/directives/role-controls.directive.ts